<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import router from "@/router";
import {
  orderMethods,
  orderOriginMethods,
  orderOriginComputed,
  userMethods,
  userComputed,
  productMethods,
  productComputed,
} from "@/state/helpers";
import { ModelListSelect } from "vue-search-select";
import Swal from "sweetalert2";

export default {
  components: { Layout, PageHeader, ModelListSelect },
  data() {
    return {
      title: "Create Order",
      form: {
        reference_num: "",
        status_id: 1,
        origin_id: 1,
        customer_id: "",
        customer: {
          first_name: "",
          last_name: "",
          phone: "",
          company: "",
          address_1: "",
          address_2: "",
          state: "",
          city: "",
          postcode: "",
        },
        items: [],
      },
      newOrderItemProduct: null,
    };
  },
  methods: {
    ...orderMethods,
    ...orderOriginMethods,
    ...userMethods,
    ...productMethods,
    onSubmit(e) {
      e.preventDefault();
      let creatBtn = this.$refs["create-order-btn"];
      let spinner = this.$refs["create-order-spinner"];
      if (creatBtn && spinner) {
        creatBtn.disabled = true;
        spinner.classList.remove("d-none");
      }
      this.addOrder(this.form)
        .then(
          function () {
            Swal.fire("Order Created!", "", "success");
            router.push({ name: "default" });
          },
          function (error) {
            Swal.fire({
              icon: "error",
              title: "An error occured",
              text: error.data && error.data.message ? JSON.stringify(error.data.message) : JSON.stringify(error),
            });
            creatBtn.disabled = false;
            spinner.classList.add("d-none");
          }
        )
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "An error occured",
            text: JSON.stringify(error),
          });
          creatBtn.disabled = false;
          spinner.classList.add("d-none");
        });
    },
    onReset() { },
    customerLabel(item) {
      return `${item.id} - ${item.first_name} ${item.last_name} - ${item.email}`;
    },
    getProductTitle(productID) {
      let label = "";
      this.products.forEach((product) => {
        if (product.id == productID) {
          label = product.name;
        }
      });
      return label;
    },
    addOrderItem() {
      if (this.newOrderItemProduct) {
        let newOrderItem = {};
        newOrderItem.product = this.newOrderItemProduct;
        newOrderItem.qty = 1;
        this.form.items.push(newOrderItem);
        this.newOrderItemProduct = null;
      }
    },
  },
  mounted() {
    this.loadOrderOrigins();
    this.loadUsers({ role: 3, perPage: 10000 });
    this.loadProducts({ perPage: 10000 });
  },
  computed: {
    ...orderOriginComputed,
    ...userComputed,
    ...productComputed,
  },
};
</script>
    
<template>
  <Layout>
    <PageHeader :title="title" />
    <b-form @submit="onSubmit" @reset="onReset">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-4">
                  <b-form-group
                    id="order-ref-group"
                    label="Order Number:*"
                    label-for="order-ref"
                  >
                    <b-form-input
                      class="text-uppercase"
                      id="order-ref"
                      type="text"
                      v-model="form.reference_num"
                      required
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group
                    id="order-origin-group"
                    label="Origin:*"
                    label-for="order-origin"
                  >
                    <b-form-select
                      class="form-control"
                      id="order-origin"
                      v-model="form.origin_id"
                      :options="orderOrigins"
                      text-field="name"
                      value-field="id"
                      required
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group
                    id="order-customer-group"
                    label="Select Customer:"
                    label-for="order-customer"
                  >
                    <div class="d-flex">
                      <model-list-select
                        class="me-2"
                        id="order-customer"
                        :list="customers"
                        option-value="id"
                        :custom-text="customerLabel"
                        v-model="form.customer_id"
                      >
                      </model-list-select>
                      <b-button type="button" @click="form.customer_id = ''"
                        >Reset</b-button
                      >
                    </div>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>

          <div class="card" v-if="form.customer_id == ''">
            <div class="card-body">
              <div class="row mb-3">
                <div class="col-6">
                  <b-form-group
                    id="customer-firstname-group"
                    label="Customer Firstname:*"
                    label-for="customer-firstname"
                  >
                    <b-form-input
                      id="customer-firstname"
                      type="text"
                      v-model="form.customer.first_name"
                      required
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-6">
                  <b-form-group
                    id="customer-lastname-group"
                    label="Customer Lastname:*"
                    label-for="customer-lastname"
                  >
                    <b-form-input
                      id="customer-lastname"
                      type="text"
                      v-model="form.customer.last_name"
                      required
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-4">
                  <b-form-group
                    id="customer-email-group"
                    label="Customer Email:*"
                    label-for="customer-email"
                  >
                    <b-form-input
                      id="customer-email"
                      type="text"
                      v-model="form.customer.email"
                      required
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group
                    id="customer-phone-group"
                    label="Customer Phone:"
                    label-for="customer-phone"
                  >
                    <b-form-input
                      id="customer-phone"
                      type="text"
                      v-model="form.customer.phone"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group
                    id="customer-company-group"
                    label="Customer Company:"
                    label-for="customer-company"
                  >
                    <b-form-input
                      id="customer-company"
                      type="text"
                      v-model="form.customer.company"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-4">
                  <b-form-group
                    id="customer-address1-group"
                    label="Customer Address Line 1:"
                    label-for="customer-address1"
                  >
                    <b-form-input
                      id="customer-address1"
                      type="text"
                      v-model="form.customer.address_1"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group
                    id="customer-address2-group"
                    label="Customer Address Line 2:"
                    label-for="customer-address2"
                  >
                    <b-form-input
                      id="customer-address2"
                      type="text"
                      v-model="form.customer.address_2"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group
                    id="customer-state-group"
                    label="Customer State:"
                    label-for="customer-state"
                  >
                    <b-form-input
                      id="customer-state"
                      type="text"
                      v-model="form.customer.state"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <b-form-group
                    id="customer-city-group"
                    label="Customer City:"
                    label-for="customer-city"
                  >
                    <b-form-input
                      id="customer-city"
                      type="text"
                      v-model="form.customer.city"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group
                    id="customer-postcode-group"
                    label="Customer Postcode:"
                    label-for="customer-postcode"
                  >
                    <b-form-input
                      id="customer-postcode"
                      type="text"
                      v-model="form.customer.postcode"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="row mb-3">
                <div class="col-12">
                  <strong>Add Order Items:</strong>
                </div>
              </div>
              <div class="row mb-4">
                <div class="col-5">
                  <model-list-select
                      class="form-control me-2"
                      id="order-item-product"
                      :list="products"
                      option-value="id"
                      option-text="name"
                      v-model="newOrderItemProduct"
                    >
                  </model-list-select>
                </div>
                <div class="col-2">
                  <b-button
                    type="button"
                    @click="addOrderItem"
                    :disabled="!newOrderItemProduct"
                    >Add</b-button
                  >
                </div>
              </div>

              <table class="table table-bordered" v-show="form.items.length">
                <thead>
                  <th class="p-3" scope="col">#</th>
                  <th class="p-3" scope="col">Product</th>
                </thead>
                <tbody>
                  <tr v-for="(orderItem, index) in form.items" :key="index">
                    <th width="100" scope="row">{{ index + 1 }}</th>
                    <td>
                      {{ getProductTitle(orderItem.product) }}
                    </td>
                    <td width="100" class="text-center">
                      <b-button
                        class="bx bx-trash-alt"
                        variant="outline-danger"
                        @click="delete form.items.splice(index, 1)"
                        type="button"
                      >
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <b-button
                    type="submit"
                    size="lg"
                    ref="create-order-btn"
                    :disabled="!form.items.length"
                  >
                    <span>Create</span>
                    <div
                      class="ms-2 spinner-border spinner-border-sm d-none"
                      role="status"
                      ref="create-order-spinner"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </Layout>
</template>